const BASE_URL = '/_serverless/polls-client/v1';
export class PollsService {
    constructor(instance, getHttpClientPromise) {
        this.getHttpClientPromise = getHttpClientPromise;
        this.fetchData = response => { var _a; return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.question) || response.data; };
        this.fetchPoll = async (pollId) => {
            var _a;
            return (_a = (await this.getHttpClientPromise())) === null || _a === void 0 ? void 0 : _a.get(`/questions/${pollId}`, this.requestOptions).then(response => this.fetchData(response));
        };
        this.createPoll = async (question) => {
            var _a;
            return (_a = (await this.getHttpClientPromise())) === null || _a === void 0 ? void 0 : _a.post(`/questions`, {
                question,
            }, this.requestOptions).then(response => this.fetchData(response));
        };
        this.updatePoll = async (question) => {
            var _a;
            return (_a = (await this.getHttpClientPromise())) === null || _a === void 0 ? void 0 : _a.patch(`/questions/${question.id}`, {
                question,
            }, this.requestOptions).then(response => this.fetchData(response));
        };
        this.vote = async (pollId, optionId) => {
            var _a;
            return (_a = (await this.getHttpClientPromise())) === null || _a === void 0 ? void 0 : _a.post(`/questions/${pollId}/vote`, {
                optionId,
            }, this.requestOptions).then(response => this.fetchData(response));
        };
        this.unvote = async (pollId, optionId) => {
            var _a;
            return (_a = (await this.getHttpClientPromise())) === null || _a === void 0 ? void 0 : _a.post(`/questions/${pollId}/unvote`, {
                optionId,
            }, this.requestOptions).then(response => this.fetchData(response));
        };
        this.getVoters = async (pollId, optionId, params) => {
            var _a;
            return (_a = (await this.getHttpClientPromise())) === null || _a === void 0 ? void 0 : _a.get(`/questions/${pollId}/options/${optionId}/voters`, Object.assign(Object.assign({}, this.requestOptions), { params })).then(response => this.fetchData(response));
        };
        this.requestOptions = { baseURL: BASE_URL, headers: { Authorization: instance } };
    }
}
//# sourceMappingURL=PollsService.js.map